import React from "react";

import { Link, Typography } from "@mui/material";

export const mapInfoTitle =
  "OPDC Local Plan Policies Map (June 2022) Information";

export const MapInfoBody = () => {
  return (
    <Typography variant="body1" paragraph>
      The Policies Map illustrates geographically all site specific policies set
      out in OPDC's Local Plan as adopted in June 2022. If you have any queries
      please get in contact at{" "}
      <Link
        target="_blank"
        rel="noreferrer"
        href="mailto:planningpolicy@opdc.london.gov.uk"
        underline="hover"
      >
        planningpolicy@opdc.london.gov.uk
      </Link>
      .
    </Typography>
  );
};
